export const isModifiedClick = (event) =>
  Boolean(
    event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
  );

// Components mounted outside <BrowserRouter> (e.g. the chatbot) cannot call useNavigate().
// Push a history entry shaped like react-router's ({ usr, key, idx }) and let the router pick it up via popstate.
export const navigateWithinApp = (path) => {
  if (typeof window === "undefined" || typeof path !== "string") {
    return false;
  }

  let target;
  try {
    target = new URL(path, window.location.origin);
  } catch {
    return false;
  }

  if (target.origin !== window.location.origin) {
    return false;
  }

  const { history, location } = window;
  const nextPath = `${target.pathname}${target.search}${target.hash}`;
  if (nextPath === `${location.pathname}${location.search}${location.hash}`) {
    return true;
  }

  const currentIndex = typeof history.state?.idx === "number" ? history.state.idx : 0;
  try {
    history.pushState(
      { usr: null, key: Math.random().toString(36).slice(2, 10), idx: currentIndex + 1 },
      "",
      nextPath
    );
    window.dispatchEvent(new PopStateEvent("popstate", { state: history.state }));
  } catch {
    window.location.assign(nextPath);
  }

  return true;
};
